
import { config, isApp, isAppSubdomain, user, canCallApp, TYPINGDELAY, getFlow} from './utils.js';
import { post, del, get } from './utils/ajax';
import * as $ from 'jquery'; // Necessary for collapse elems
import * as BI from './tracking/bi.js';
import { setNativeFilters } from './filters/app-filters.js';
import { getUrlParam } from './utils/url-helper.js';
import personalize_sizes from './components/personalize_sizes';
import { onLoad } from './utils/onLoad';
import { userAppliedFilters } from './filters/transfer-filters.js';

// Data models tracking (BI & Zendesk)
import { UserAlertCompleteBIModel, UserAlertAbandonBIModel, UserAlertCreateBIModel } from './BI/models';

const UNIQUE_SIZE_ID = 24;

let userSizes = {
    ids: user && user.sizes ? user.sizes.split("-") : [],
    hasSizes: user && user.sizes,
    permalinks: []
};
userSizes.ids.forEach(sizeId => {
    let input = document.querySelector('[data-size-id="' + sizeId + '"] input');
    if (sizeId == UNIQUE_SIZE_ID || input == null) {
        return;
    } else {
        userSizes.permalinks.push(input.value);
    }
});

let filteringBySize = false;

onLoad(() => {
    //
    // Follow / Unfollow brands
    const followBrandBtn = document.querySelector('.js-follow-brand');

    if (followBrandBtn) {
        const brandId = followBrandBtn.dataset.brandId,
            followText = followBrandBtn.querySelector('.js-follow'),
            followingText = followBrandBtn.querySelector('.js-following');

        followBrandBtn.addEventListener('click', () =>{
            const isFollowing = followText.classList.contains('d-none');

            post("/profile/json_" + (isFollowing ? 'remove' : 'add') + "_user_brand", {brandId: brandId});
            followBrandBtn.dataset.followingBrand = !isFollowing;
            followBrandBtn.classList.toggle('button-secondary', !isFollowing);
            followBrandBtn.classList.toggle('button-primary', isFollowing);
            followingText.classList.toggle('d-none');
            followText.classList.toggle('d-none');
        });
    }


    //
    // Desktop filters
    // Add a listener to catch every filter input change
    const desktopFilters = document.querySelector('.js-desktop-filters-container');
    if (desktopFilters) {

        const categoryGroups = document.querySelectorAll('.js-category-group');
        let chosenBrands = new Map();

        updateAllChosenBrands(chosenBrands);

        // We look for click events, not change, to allow users to open an already selected category
        ['click'].forEach(eventType => {
            desktopFilters.addEventListener(eventType, e => {
            
                if (e.target && e.target.dataset.filterType) {
                    const input = e.target;
                    const filterContainer = input.closest('.js-filter-container');
                    const categoriesCollapse = filterContainer.querySelector('#category-collapse');
                    
                        switch (input.dataset.filterType) {

                            case 'category': {
                                if (input.checked) {
                                    //Show & save chosen category
                                    let selectedFilterLabel = filterContainer.querySelector('.js-selected-filter-label');
                                    selectedFilterLabel.innerText = input.dataset.categoryName;
                                    selectedFilterLabel.dataset.selectedCategory = input.value;

                                    // If it has child categories, hide the rest and show them
                                    categoryGroups.forEach(group => group.classList.add('d-none'));

                                    // Show selected category children or itself if there's no children
                                    let categoryGroup = document.querySelector('[data-parent-category-id="' + input.dataset.id + '"');
                                    if (categoryGroup) {
                                        document.querySelector('[data-parent-category-id="' + input.dataset.id + '"').classList.remove('d-none');
                                        // If not at top, scroll subcategories container content to top
                                        categoriesCollapse.scrollTop = 0;
                                    } else {
                                        input.closest('.js-category-group').classList.remove('d-none');
                                    }
                                }
                                break;
                            }
                            
                            case 'brand': {
                           
                                let brandNames = "";
                              
                                // Update chosen brands
                                if (!input.checked) {
                                    chosenBrands.delete(input.value);
                                    if (input.classList.contains('remove-on-click')) {
                                        chosenBrands.delete(input.value);
                                        input.closest('.d-flex').remove();
                                    }
                                } else {
                                    updateChosenBrand(input, chosenBrands);
                                }

                                // Update label brand
                                if (chosenBrands.size >= 1) {
                                    const brandArray = Array.from(chosenBrands.values());
                                    const brandNamesArray = brandArray.map(({ brandName }) => brandName);
                                    brandNames = brandNamesArray.join(", ");
                                } 
                            
                                filterContainer.querySelector('.js-selected-filter-label').innerText = brandNames;
                                break;
                            }
                            case 'status': {
                                //Show chosen status
                                let chosenStatus = '';
                                filterContainer.querySelectorAll('[name="status[]"]:checked').forEach(checkbox => {
                                    chosenStatus += checkbox.parentElement.previousElementSibling.innerText + ', ';
                                });
                                //Show chosen status in the label and remove the last ", "
                                filterContainer.querySelector('.js-selected-filter-label').innerText = chosenStatus.slice(0, -2);
                                break;
                            }
                            case 'size': {
                                //Show chosen sizes
                                setSizes();
                                filteringBySize = true;
                                break;
                            }
                            case 'color': {
                                //Show chosen sizes
                                let chosenColors = '';
                                filterContainer.querySelectorAll('[name="color[]"]:checked').forEach(checkbox => {
                                    chosenColors += checkbox.nextElementSibling.querySelector('.js-color-name').innerText + ', ';
                                });
                                //Show choosen sizes in the label and remove the last ", "
                                filterContainer.querySelector('.js-selected-filter-label').innerText = chosenColors.slice(0, -2);
                                break;
                            }
                        }
                        desktopFiltersApply();
                    }
                });
            });

        //
        // Desktop filters
        // Price filter requires the action of clicking before being applied
        let priceFilterBtn = document.querySelector('[data-filter-type="price"]');
        priceFilterBtn.addEventListener('click', () => desktopFiltersApply());

        //
        // Desktop filters
        // Brands input search
        let brandTimer;
        const brandInput = document.querySelector('.js-search-brand');
   
        brandInput.addEventListener('input', e => {
            const inputValue = e.target.value;
            const brandsResultsPreviousContainer = document.querySelector('.js-filter-brands-results-previous');
            brandsResultsPreviousContainer.innerHTML = '';

            if (inputValue === '') {
                window.setTimeout(function() {
                    chosenBrands.forEach(({ permalink, brandName }) => {
                        const brandSelectedInput = document.getElementById(`brand-${permalink}-d`);
                        if (brandSelectedInput) {
                            brandSelectedInput.checked = true;
                        } else {
                            const brandsResultsPreviousContainer = document.querySelector('.js-filter-brands-results-previous');
                            brandsResultsPreviousContainer.appendChild(templateSelectedBrand(permalink, brandName, true, true));
                        }
                    })
                }, 1000);

            } else {
               
                if (chosenBrands.size >= 1) {
                    chosenBrands.forEach(({ permalink, brandName }) => {
                        const brandsResultsContainer = document.querySelector('.js-filter-brands-results');
                        brandsResultsPreviousContainer.classList.add("pt-3");
                        brandsResultsContainer.classList.remove("pt-3");
                        brandsResultsPreviousContainer.appendChild(templateSelectedBrand(permalink, brandName, true, true));
                    });
                }
            } 

            //Wait for user multiple chars input
            clearTimeout(brandTimer);
            brandTimer = setTimeout(() => getBrandsStartingWith(inputValue), TYPINGDELAY);
        });

        //
        // Desktop filters
        // Only one collapsible open at the same time
        $('.filters-desktop-collapse').on('show.bs.collapse', () => {
            $('.filters-desktop-collapse:not(.collapsing)').collapse('hide');
        });

        // Desktop filters
        // Add styles to applied filters container when it is in sticky position
        const appliedFiltersContainer = () => {
            const appliedFiltersChips = document.querySelector('[data-applied-filters]');
            if (appliedFiltersChips) {
                appliedFiltersChips.classList.toggle('py-2', appliedFiltersChips.getBoundingClientRect().top < 10);
                appliedFiltersChips.classList.toggle('shadow', appliedFiltersChips.getBoundingClientRect().top < 10);
            }
        }
        appliedFiltersContainer();
        window.onscroll = () => appliedFiltersContainer();

        //
        // Desktop filters
        // On load, if theres a selected category, show it and its siblings and hide root categories
        const initialSelectedCategory = document.querySelector('input[data-filter-type="category"]:checked'),
            rootCategories =  document.querySelector('#category-collapse > .js-category-group:first-child');
        if (initialSelectedCategory) {
            initialSelectedCategory.closest('.js-category-group').classList.remove('d-none');
        } else {
            rootCategories.classList.remove('d-none');
        }

        //
        // Desktop`filters
        // Go to parent category
        document.querySelectorAll('.js-to-parent-category').forEach(backBtn => {
            backBtn.addEventListener('click', e => {
                e.preventDefault();
                categoryGroups.forEach(group => group.classList.add('d-none'));
                let parentId = backBtn.closest('.js-category-group').dataset.parentCategoryId;
                document.querySelector('#category-id-' + parentId).closest('.js-category-group').classList.remove('d-none');
            });
        });
    }

    //Chips scroll setup
    const chipsContainer = document.querySelector('[data-seo-chips="container"]');
    if (chipsContainer) {
        document.querySelectorAll('.scroll-chips').forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.dataset.scrollDirection == 'left') {
                    chipsContainer.scrollLeft -= 200;
                } else if (btn.dataset.scrollDirection == 'right') {
                    chipsContainer.scrollLeft += 200;
                }
            });
        });
        toggleSeoChipsScrolling();
        window.addEventListener('resize', toggleSeoChipsScrolling);
    }

    // App - User alert create
    const userAlertContainer = document.querySelector('.js-user-alert');

    if (userAlertContainer) {
        let offSetElementToScroll = 0;
        const userAlertButton = userAlertContainer.querySelector('.js-user-alert-button');
        const userAlertButtonFixed = userAlertContainer.querySelector('.js-user-alert-button-fixed');
        const userAlertButtonCreate = userAlertContainer.querySelector('.js-alert-btn-create');
        const userAlertCreateKo = document.getElementById('user-alert-create-ko');
        const userAlertCreateOk = document.getElementById('user-alert-create-ok');
        const { name: alertName, product_request: productRequest } = config.userAlert;
        const userAlertDataToSend = { alertName, productRequest: JSON.stringify(productRequest) };
        const flow = getFlow();
        const brand = productRequest.brands || null;
        const size = productRequest.sizes || null;
        const status = productRequest.statuses || null;
        const price = [productRequest.minPrice || null, productRequest.maxPrice || null];
        const userAlertCompleteBIModel = new UserAlertCompleteBIModel(config.user.id, flow, brand, size, status, price);
        const userAlertAbandonBIModel = new UserAlertAbandonBIModel(config.user.id, flow, brand, size, status, price);
        const userAlertCreateBIModel = new UserAlertCreateBIModel(config.user.id, flow, brand, size, status, price);


        const visibleCreateButton = () => !userAlertButtonCreate?.classList.contains('d-none');

        const offsetScroll = (el) => {
            const sizeAndPositionEleToScroll = el.getBoundingClientRect();
            offSetElementToScroll = sizeAndPositionEleToScroll.top + document.body.scrollTop + el.offsetHeight;
        }

        const scrollButton = () => {
            if (userAlertButton) {
                offsetScroll(userAlertButton);
                window.addEventListener("scroll", () => {
                    let posY = document.scrollingElement.scrollTop;
                    if ((posY > offSetElementToScroll && posY !== 0) && visibleCreateButton()) {
                        userAlertButtonFixed.classList.remove('d-none');
                    } else {
                        userAlertButtonFixed.classList.add('d-none');
                    }

                })
            }
        }

        const createUserAlertPost = () => (
            post("/api/v5/user/user-alert", userAlertDataToSend).then(response => {
                let success = false;
                if (response) {
                    success = true;
                    const { id } = response;
                    config.userAlert.id = id;
                }
                return success;
             })
        )

        const deleteUserAlertPost = () => (
            del(`/api/v5/user/user-alert/${config.userAlert.id}`,{}).then(response => {
                let success = false;
                if (response) {
                    success = true;
                    const { id } = response;
                    config.userAlert.id = null;
                }
                return success;
             })
        )

        const toggleAlert = (element, show) => {
            element?.classList.toggle('d-flex', show);
            element?.classList.toggle('d-none', !show);
            offsetScroll(userAlertButton);
        }

        const toggleAlertButton = (show) =>{
            userAlertButton.classList.toggle('button-primary', show);
            userAlertButton.classList.toggle('button-secondary', !show);
            userAlertButton.children[0].classList.toggle('d-none', !show);
            userAlertButton.children[0].classList.toggle('d-flex', show);
            userAlertButton.children[0].classList.toggle('align-items-center', show);
            userAlertButton.children[1].classList.toggle('d-none', show);
            userAlertButton.children[1].classList.toggle('d-flex', !show);
            userAlertButton.children[1].classList.toggle('align-items-center', !show);
        }

        const createUserAlert = () => {
            $('#user_alert_summary').modal('show');
        }

        const deleteUserAlert = async () => {
            const success = await deleteUserAlertPost();
            if (success) {
                toggleAlert(userAlertCreateOk, !success);
                toggleAlert(userAlertCreateKo, success);
                toggleAlertButton(success);
            }
        }

        // On click button "Crear alerta"
        $('#user_alert_summary').on('click','.js-user-alert-create', async () => {
            const success = await createUserAlertPost();
            if (success) {
                toggleAlert(userAlertCreateOk, success);
                toggleAlert(userAlertCreateKo, !success);
                toggleAlertButton(!success);
                BI.track(userAlertCompleteBIModel);
            }
         });

          // On click button "Cancelar alerta"
        $('#user_alert_summary').on('click','.js-user-alert-cancel', () => {
            BI.track(userAlertAbandonBIModel);
        });

        // On click icon "Cerrar alerta"
        $('#user_alert_summary').on('click','.close', () => {
            BI.track(userAlertAbandonBIModel);
        })

        userAlertButton.addEventListener('click', () => alertBtnHandler());
        userAlertButtonFixed.addEventListener('click', () => alertBtnHandler());

        const alertBtnHandler = () => {
            const userAlertIsSaved = config.userAlert.id !== null;
            if (!userAlertIsSaved) {
                createUserAlert();
                BI.track(userAlertCreateBIModel);
            }
            userAlertIsSaved && deleteUserAlert();
        };

       scrollButton();


    }

    setNativeFilters();

    if ( isApp() || isAppSubdomain() ) {
        personalize_sizes.init();
        canCallApp('transferFilters') && Trendier.transferFilters(JSON.stringify(userAppliedFilters));
    }
});

// Desktop filters
// Function to generate dinamic template
const templateSelectedBrand = (permalink, brandName, checked = false, removeOnClick = false) => {
    const div = document.createElement('div');
    div.classList.add('d-flex', 'align-items-center', 'justify-content-between', 'py-2');
    div.innerHTML = `
      <label class="font-body flex-grow-1 js-filter-label mb-0" for="brand-${permalink}-d">${brandName}</label>
      <div class="custom-control custom-checkbox">
        <input type="checkbox" name="brand[]" id="brand-${permalink}-d" data-brand-name="${brandName}" class="custom-control-input ${removeOnClick ? "remove-on-click":""}" value="${permalink}" data-filter-type="brand" ${checked === true ? "checked" :""}>
        <label class="custom-control-label" for="brand-${permalink}-d"></label>
      </div>
    `;
    return div;
  };

  // Desktop filters
  // Update previous checkbox in chosen brands
  const updateChosenBrand = (input, chosenBrands) => {
        chosenBrands.set(input.value, {
            brandName: input.dataset.brandName,
            permalink: input.value,
        });
  };

  // Desktop filters
  // Update previous checkbox in chosen brands
  const updateAllChosenBrands = (chosenBrands) => {
    const wrapperResult = document.querySelector('.js-filter-brands-results');
    const wrapperResultInputChecked = wrapperResult?.querySelectorAll('[name="brand[]"]:checked');

    wrapperResultInputChecked.forEach((input) => {
        updateChosenBrand(input, chosenBrands);
    });
  };

// Desktop filters
// Function to set sizers properly
function setSizes()
{
    let chosenSizes = '';
    const filterContainer = document.getElementById('sizes-collapse');
    filterContainer.querySelectorAll('[name="sizes[]"]:checked').forEach(checkbox => {
        //Only show the size main label, not the EU or EUR equivalency
        if (checkbox.offsetParent !== null) { //Only show labels of current visible filters
            let sizeLabel = checkbox.parentElement.previousElementSibling.innerText;
            chosenSizes += sizeLabel.slice(0, sizeLabel.indexOf('/') - 1) + ', ';
        }
    });
    //Show chosen sizes in the label and remove the last ", "
    filterContainer.previousElementSibling.querySelector('.js-selected-filter-label').innerText = chosenSizes.slice(0, -2);
}

//
// Desktop filters
// Function to get brands starting with the input value and show them
function getBrandsStartingWith(brandName)
{
    let params = {
        limit: 10,
    };

    if (brandName.length > 0) {
        params.name = brandName;
    } else {
        // When deleting brand search, set a high limit to show all popular brands
        params.limit = 1000;
        params.categoryId = config.currentVertical.id;
    }

    get("/api/v4/brand/search", params, true).then(brands => {
        const filterBrandsResults = document.querySelector('.js-filter-brands-results');
        filterBrandsResults.innerHTML = "";

       document.querySelector('.js-filter-brands-no-results').classList.toggle('d-none', brands.length != 0);

        brands.forEach(({slug, name}) => {
            filterBrandsResults.appendChild(templateSelectedBrand(slug, name));
        });
    });
}

//
// Desktop filters
// Function to show selected products, change url and title
function desktopFiltersApply()
{
    // Post form with js-scroll to get live grid and the dynamic parameter to get the dynamic_grid template
    const form = document.querySelector('form.js-filter'),
        searchbar = document.querySelector('.js-search-bar-header input[name="txt"]')
    ;
    let formData = new FormData(form);

    // Append to form data to retrieve only grid content
    formData.append('js-scroll', 1);
    formData.append('dynamic', 1);
    // Append to form data search input text
    formData.append(searchbar.name, searchbar.value);

    // If there are sizes selected, the user custom sizes are ignored
    if ( filteringBySize || getUrlParam( 'no_user_sizes' ) !== false ) {
        formData.append('no_user_sizes', 1);
    } else if (userSizes.hasSizes && userSizes.permalinks.length) {
        formData.delete('sizes[]');
        formData.append('sizes[]', userSizes.permalinks);
    }

    post('/filters/apply_filters', formData, false).then(result => {
        // Show the result in the products container
        if (document.querySelector('#filters-output .products-grid')) {
            document.querySelector('#filters-output .products-grid').innerHTML = result;
        }

        const gridDetails = JSON.parse(document.getElementById('grid-details').innerHTML),
            breadcrumb = document.querySelector('.js-breadcrumb'),
            dynamicBreadcrumb = document.getElementById('dynamic-breadcrumb').content.cloneNode(true),
            gridTitle = document.querySelector('.js-grid-title'),
            gridCount = document.querySelector('.js-grid-count'),
            titleBreadcrumbContainer = document.querySelector('.js-title-container'),
            filterChips = document.querySelector('.js-filter-chips'),
            dynamicFilterChips = document.getElementById('dynamic-filter-chips').content.cloneNode(true),
            userAlert = document.querySelector('.js-user-alert'),
            dynamicUserAlert = document.getElementById('dynamic-user-alert').content.cloneNode(true).querySelector('.js-user-alert');

        // Set and update browser url removing ajax query parameters
        let cleanUrl = new URL(gridDetails.url, window.location.href);
        cleanUrl.searchParams.delete('js-scroll');
        cleanUrl.searchParams.delete('dynamic');
        window.history.pushState({}, "", cleanUrl.href);
        // Set title and metas according to selected filter
        document.title = gridDetails.metaTitle;
        document.querySelector('meta[name="description"]').setAttribute("content", gridDetails.metaDescription);
        document.querySelector('meta[name="keywords"]').setAttribute("content", gridDetails.metaKeywords);
        // Update searchbar placeholder
        searchbar.placeholder = gridDetails.searchbarPlaceholder;
        // Update page H1 Title and results count
        gridTitle.innerText = gridDetails.title;
        gridCount.innerText = gridDetails.count;
        // Update breadcrumb
        breadcrumb.innerHTML = "";
        breadcrumb.appendChild(dynamicBreadcrumb);
        // Update chips
        filterChips.innerHTML = "";
        filterChips.appendChild(dynamicFilterChips);
        // Update user alerts
        if (userAlert && dynamicUserAlert) {
            userAlert.innerHTML = '';
            userAlert.appendChild(dynamicUserAlert.firstElementChild);
        }
        // If H1 box is hidden (like in /vertical), make it visible and arrange spacing
        $(titleBreadcrumbContainer).collapse('show');
        document.getElementById('content-wrapper').classList.remove('pt-5');
        showHideSizes(gridDetails.selectedSizes, gridDetails.possibleSizes);
        showSEOChips(gridDetails.seoChips);
    });
}

const showSEOChips = (chips) => {
    document.querySelectorAll('[data-seo-chips]').forEach(el => {
        if (chips.length < 1) {
            el.classList.replace('d-flex', 'd-none');
            document.querySelector('hr[data-seo-chips]').classList.add('d-none');
        } else {
            el.classList.replace('d-none', 'd-flex');
            document.querySelector('hr[data-seo-chips]').classList.remove('d-none');
        }
    });
    if (chips.length >= 1) {
        const template = document.getElementById('tpl-seo-chip').innerHTML.trim(),
            container = document.querySelector('[data-seo-chips="container"]'),
            spacer = document.createElement('div');
        spacer.className = 'px-2';

        container.innerHTML = ''; // reset container
        chips.forEach((chip, index) => {
            if (index == 0) { //Add spacer at front of the chips
                container.appendChild(spacer.cloneNode());
            }
            const el = parseTemplate(template);
            el.innerText = chip.name;
            el.href = chip.url;
            if (index == chips.length-1) {
                el.classList.remove("mr-2");
            }
            container.appendChild(el);
            if (index == chips.length-1) { //Add spacer at the end of the chips
                container.appendChild(spacer);
                toggleSeoChipsScrolling();
            }
        });
    }
}

//
// Desktop filters
// Function to show or hide chips scrolling buttons
function toggleSeoChipsScrolling()
{
    const chipsContainer = document.querySelector('[data-seo-chips="container"]'),
        chipsContainerParent = chipsContainer.parentElement;
    if (chipsContainer) {
        if (chipsContainer.clientWidth < chipsContainer.scrollWidth) { //if content is wider than container, then show scroll buttons
            chipsContainerParent.querySelectorAll('button.scroll-chips').forEach(btn => btn.classList.remove('d-none'));
        } else {
            chipsContainerParent.querySelectorAll('button.scroll-chips').forEach(btn => btn.classList.add('d-none'));
        }
    }
}

const parseTemplate = (html) => {
    let div = document.createElement('div');
    div.innerHTML = html;
    return div.firstChild;
}

//
// Desktop filters
// Function to get sizes by category through json filled template
function showHideSizes(selectedSizes, possibleSizes)
{
    const sizes = document.querySelectorAll('#sizes-collapse [data-size-id]');
    let superior = [],
        inferior = [],
        zapatos = [],
        babiesClothing = [],
        childrenClothing = [],
        babiesShoes = [],
        childrenShoes = [],
        superiorCount = 0,
        inferiorCount = 0,
        zapatosCount = 0,
        babiesClothingCount = 0,
        childrenClothingCount = 0,
        babiesShoesCount = 0,
        childrenShoesCount = 0;
    document.querySelectorAll('#sizes-collapse [data-size-id][data-size-type="superior"]').forEach(size => superior.push(parseInt(size.dataset.sizeId)));
    document.querySelectorAll('#sizes-collapse [data-size-id][data-size-type="inferior"]').forEach(size => inferior.push(parseInt(size.dataset.sizeId)));
    document.querySelectorAll('#sizes-collapse [data-size-id][data-size-type="zapatos"]').forEach(size => zapatos.push(parseInt(size.dataset.sizeId)));
    document.querySelectorAll('#sizes-collapse [data-size-id][data-size-type="babies-clothing"]').forEach(size => babiesClothing.push(parseInt(size.dataset.sizeId)));
    document.querySelectorAll('#sizes-collapse [data-size-id][data-size-type="children-clothing"]').forEach(size => childrenClothing.push(parseInt(size.dataset.sizeId)));
    document.querySelectorAll('#sizes-collapse [data-size-id][data-size-type="babies-shoes"]').forEach(size => babiesShoes.push(parseInt(size.dataset.sizeId)));
    document.querySelectorAll('#sizes-collapse [data-size-id][data-size-type="children-shoes"]').forEach(size => childrenShoes.push(parseInt(size.dataset.sizeId)));

    const lastSelectedSize = selectedSizes.length - 1;
    const chosenSizes = document.querySelector('[href="#sizes-collapse"] .js-selected-filter-label');
    chosenSizes.innerHTML = '';

    sizes.forEach((size) => {
        const sizeId = parseInt(size.dataset.sizeId);
        if (possibleSizes.includes(sizeId) || possibleSizes.includes(sizeId.toString())) {
            size.classList.remove('d-none');
            size.classList.add('d-flex');
            const selectedSizePos = selectedSizes.indexOf(sizeId);

            if (selectedSizePos !== -1) {
                const sizeLabel = size.querySelector('label').innerText;

                size.querySelector('input').checked = true;
                chosenSizes.innerHTML += sizeLabel.slice(0, sizeLabel.indexOf('/') - 1) + (selectedSizePos === lastSelectedSize ? '' : ', ');
            }
        } else {
            if (superior.includes(sizeId)) {
                superiorCount++;
            }
            else if (inferior.includes(sizeId)) {
                inferiorCount++;
            }
            else if (zapatos.includes(sizeId)) {
                zapatosCount++;
            }
            else if (babiesClothing.includes(sizeId)) {
                babiesClothingCount++;
            }
            else if (childrenClothing.includes(sizeId)) {
                childrenClothingCount++;
            }
            else if (babiesShoes.includes(sizeId)) {
                babiesShoesCount++;
            }
            else if (childrenShoes.includes(sizeId)) {
                childrenShoesCount++;
            }
            size.classList.add('d-none');
            size.classList.remove('d-flex');
        }
    });

    document.querySelector('.js-superior-label')?.classList.toggle('d-none', superior.length == superiorCount);
    document.querySelector('.js-inferior-label')?.classList.toggle('d-none', inferior.length == inferiorCount);
    document.querySelector('.js-zapatos-label')?.classList.toggle('d-none', zapatos.length == zapatosCount);
    document.querySelector('.js-babies-clothing-label')?.classList.toggle('d-none', babiesClothing.length == babiesClothingCount);
    document.querySelector('.js-children-clothing-label')?.classList.toggle('d-none', childrenClothing.length == childrenClothingCount);
    document.querySelector('.js-babies-shoes-label')?.classList.toggle('d-none', babiesShoes.length == babiesShoesCount);
    document.querySelector('.js-children-shoes-label')?.classList.toggle('d-none', childrenShoes.length == childrenShoesCount);
}
